import React from 'react'
import cx from 'classnames'

import { AdoptionComponent } from '../../../constants/AdoptionComponent'
import { useDsAdoptionAttribute } from '../../../utils/dsAdoption'
import { FormFieldTextBelow } from '../../forms/FormField'
import { FormFieldLabelContainer } from '../../forms/FormField/FormFieldLabelContainer'
import {
  FieldClassesProps,
  FormFieldLabelContainerProps,
  HelpTextProps,
} from '../../forms/FormField/interfaces'

import cm from './FormFieldContainer.module.css'

const DEFAULT_INFOTEXT_WIDTH = 200

type Props = FormFieldLabelContainerProps &
  HelpTextProps & {
    fieldLabelId: string
    fieldInputId: string
    fieldClasses?: FieldClassesProps
    labelClassName?: string
    children: React.ReactNode
    className?: string
  }

export const FormFieldContainer = ({
  label,
  helpText,
  errorText,
  infoText,
  required,
  invalid,
  lozenge,
  infoTextWidth = DEFAULT_INFOTEXT_WIDTH,
  disabled,
  fieldInputId,
  fieldLabelId,
  fieldClasses,
  labelClassName,
  className,
  children,
}: Props) => {
  const hasTextBelow = helpText || errorText
  const hasLabel = label || lozenge || infoText || required

  const hasAdditionalText = hasLabel || hasTextBelow
  const adoptionAttribute = useDsAdoptionAttribute(AdoptionComponent.FORM_FIELD_CONTAINER)

  return (
    <div
      className={cx(cm.container, hasAdditionalText && cm.verticalContainer, className)}
      {...adoptionAttribute}
    >
      {label && (
        <FormFieldLabelContainer
          inputId={fieldInputId}
          label={label}
          id={fieldLabelId}
          infoText={infoText}
          lozenge={lozenge}
          infoTextWidth={infoTextWidth}
          required={required}
          disabled={disabled}
          fieldClasses={fieldClasses}
          labelClassName={labelClassName}
        />
      )}
      <div className={cx(cm.inputContainer, { 'm-t-xs': hasLabel, 'm-b-xs': hasTextBelow })}>
        {children}
      </div>
      <FormFieldTextBelow
        helpText={helpText}
        errorText={errorText}
        showError={invalid}
        disabled={disabled}
      />
    </div>
  )
}
